import React from 'react';
import { Text } from 'grommet';
import TextCell from 'granite-admin/core/components/Table/TextCell';

const STATUS_COLORS = {
  not_running: 'status-not-running',
  running: 'status-running',
  disabled: 'status-disabled',
};

const FlowCell = ({ value, ...rest }) => {
  if (!value || value.status === 'NA') return <TextCell {...rest} data={<Text>NA</Text>} />;
  const color = STATUS_COLORS[value.status] || 'status-disabled';
  const displayText = value.last_active
    ? new Date(value.last_active).toLocaleString()
    : value.status.replace('_', ' ');
  return (
    <TextCell
      {...rest}
      data={
        <Text color={color}>{displayText}</Text>
      }
    />
  );
};

export default FlowCell;
